import { createFileRoute } from '@tanstack/react-router';
import Printouts from 'src/pages/Organization/Event/Printouts';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/printouts',
)({
  component: Printouts,
});
